import {
  AfterViewInit,
  ContentChildren,
  Directive,
  Input,
  QueryList,
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  // tslint:disable-next-line:max-line-length
  // tslint:disable-next-line:directive-selector (no termino de entender porque canta, aqui https://angular.io/guide/styleguide#style-02-06 dice de usar camel case)
  selector: 'fieldset',
  exportAs: 'fieldset',
})
export class FieldsetDirective implements AfterViewInit {
  constructor() {}

  private _disabled: boolean;
  @Input()
  public get disabled(): boolean {
    return this._disabled;
  }
  public set disabled(value: boolean) {
    if (this.controles) {
      this.controles.forEach((control) => {
        if (value) {
          control.control.disable();
        } else {
          control.control.enable();
        }
      });
    }
    this._disabled = value;
  }
  @ContentChildren(NgModel, { descendants: true })
  private controles: QueryList<NgModel>;

  ngAfterViewInit(): void {
    if (this.disabled) {
      this.controles.forEach((control) => {
        control.control.disable();
      });
    }
  }
  validate(): boolean {
    let result = true;
    this.controles.forEach((control) => {
      control.control.markAsTouched();
      control.control.updateValueAndValidity();
      if (!control.valid) {
        result = false;
      }
    });
    return result;
  }
}
